export type Key = "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "." | "neg" | "del" | "hint" | "skip" | "enter";

/** On-screen keypad. Uses pointerdown so taps register instantly on phones. */
export function Keypad({ onKey, enterLabel, hintDisabled }: { onKey(k: Key): void; enterLabel: string; hintDisabled?: boolean }) {
  const btn = (k: Key, label: string, cls = "k", aria?: string, disabled?: boolean) =>
    <button key={k} className={cls} aria-label={aria} disabled={disabled} onPointerDown={(e) => { e.preventDefault(); onKey(k); }}>{label}</button>;
  return <div className="pad">
    {btn("7", "7")}{btn("8", "8")}{btn("9", "9")}{btn("del", "⌫", "k f", "Delete")}
    {btn("4", "4")}{btn("5", "5")}{btn("6", "6")}{btn("hint", "Hint", "k f", undefined, hintDisabled)}
    {btn("1", "1")}{btn("2", "2")}{btn("3", "3")}{btn("skip", "Skip", "k f")}
    {btn("neg", "−", "k", "Negative")}{btn("0", "0")}{btn(".", ".", "k", "Decimal point")}{btn("enter", enterLabel, "k enter")}
  </div>;
}
